<!-- 组织架构中的人员 -->
<template>
  <div class="person_table">
    <el-table :data="personTable" highlight-current-row height="100%" border @row-click="rowClick"
      @selection-change="handleSelectionChange">
      <template slot="empty">
        <img :src="zanwu" alt="" />
        <p style="font-size: 16px; color: #000; margin-top: 36px">暂无数据</p>
      </template>
      <el-table-column v-if="type == 2 && showSelection" type="selection" align="center" width="42" header-align="center" />
      <el-table-column v-if="type == 2" label="登录名" prop="username" min-width="120px" sortable />
      <el-table-column v-slot="{ row }" label="姓名" prop="name" sortable align="center" min-width="120px">
        <el-link v-if="type == 1" type="primary" @click="$emit('user', row)">
          <span class="tabLinkSpan" :title="row.name">{{ row.name }}</span>
        </el-link>
        <span v-else-if="!row.isSignature" slot="reference" class="tabLinkSpan" :title="row.name">{{ row.name }}</span>
        <el-popover v-else placement="bottom" trigger="click" @show="pieView(row)">
          <el-image style="width: 200px; height: 200px" :src="imageUrl" alt="签名" fit="contain"></el-image>
          <el-link slot="reference" type="primary">
            <span class="tabLinkSpan" :title="row.name">{{ row.name }}</span>
          </el-link>
        </el-popover>
      </el-table-column>
      <el-table-column label="性别" prop="sex" sortable align="center" min-width="80">
        <template #default="{ row }">
          <span v-if="row.sex == '1'">男</span>
          <span v-if="row.sex == '2'">女</span>
        </template>
      </el-table-column>
      <el-table-column label="所属部门" sortable prop="deptList" min-width="300px" align="center">
        <template #default="{ row }">
          <el-popover :disabled="!isShow(row)" trigger="hover" placement="top" popper-class="deptNamePopperStyle">
            <div class="popover-wrapper">
              <div v-for="(name, index) in row.deptList" :key="index" :class="{ isHead: name.isHead, isMain: name.isMain }" class="deptName">
                <p class="icon"></p>
                <p class="fullDeptName">
                  {{ name.fullDeptName }}
                </p>
              </div>
            </div>
            <div slot="reference" class="name-wrapper">
              <span v-for="(name, index) in row.deptList" :key="index" class="deptName" :class="{ isHead: name.isHead, isMain: name.isMain }">{{ name.deptName }}</span>
            </div>
          </el-popover>
          <!-- <div v-else class="name-wrapper">
            <span v-for="(name, index) in row.deptList" :key="index" class="deptName">{{ name.deptName }}</span>
          </div> -->
        </template>
      </el-table-column>
      <template v-if="type == 1">
        <el-table-column label="手机号" prop="phone" align="center" min-width="120px" />
        <el-table-column label="是否主管" align="center" min-width="120px">
          <template #default="{ row }">
            <img v-if="row.isHead === 1" :src="isHead" alt="是" />
            <img v-if="!row.isHead" :src="noHead" alt="否" />
          </template>
        </el-table-column>
        <el-table-column label="账号状态" align="center" min-width="120px">
          <template #default="{ row }">
            <userStatus :status="row.isEnabled" />
          </template>
        </el-table-column>
      </template>
      <template v-else>
        <el-table-column label="操作人" min-width="120px" prop="checkInUser" />
        <el-table-column label="上传时间" min-width="180px" prop="checkInDate" />
        <el-table-column label="是否上传签名" min-width="100px">
          <template #default="{ row }">
            {{ ["否", "是"][row.isSignature] }}
          </template>
        </el-table-column>
        <el-table-column v-if="downSignature" label="操作" width="120px">
          <template slot-scope="scope">
            <span style="cursor: pointer;color:var(--theme-color)" @click="download(scope.row)">下载</span>
          </template>
        </el-table-column>
      </template>
    </el-table>
  </div>
</template>

<script>
import userStatus from "@/CommonDP/components/status/userStatus";
import tzService from "@/CommonDP/service/tz-service";
import { mapState } from "vuex";
import { checkPermission } from "@/CommonDP/utils/routeAuth";
export default {
  components: { userStatus },
  props: {
    personTable: { type: Array, required: true },
    type: { type: Number, required: false, default: 0 }, // 1 为组织架构添加部门人员 2 电子签名
    showSelection: { type: Boolean, default: true }
  },
  data() {
    return {
      downSignature: checkPermission(this.$allPerms.SIGNATURE_DOWN),
      selectedRows: [],
      zanwu: require("@/CommonDP/assets/暂无数据.png"),
      isHead: require("@/CommonDP/assets/org/isHead.png"),
      noHead: require("@/CommonDP/assets/org/noHead.png"),
      imageUrl: ''
    };
  },
  computed: {
    ...mapState({
      enterpriseId: (state) => state.enterprise.enterpriseId
    })
  },
  watch: {
    imageUrl(newValue, oldValue) {
      if (oldValue) {
        URL.revokeObjectURL(oldValue);
      }
    }
  },
  created() {},
  methods: {
    isShow(row) {
      if (row.deptList && row.deptList.length > 0) {
        const show = row.deptList.find(({ fullDeptName }) => fullDeptName !== null);
        if (show) return true;
        else return false;
      }
    },
    rowClick(val) {
      this.$emit("handleChange", val);
    },
    handleSelectionChange(rows) {
      this.selectedRows = rows;
      this.$emit("rowsSelected", this.selectedRows);
    },

    getSelectedRows() {
      return this.selectedRows;
    },

    // 下载
    async download(row) {
      if (row.isSignature === 1) {
        const fileID = row.userId;
        tzService.stampDownload(fileID).then(blob => {
          if (blob.type === "application/json") {
            const fileReader = new FileReader();
            fileReader.onloadend = () => {
              const jsonData = JSON.parse(fileReader.result);
              // 后台信息
              this.$message({ message: jsonData.message, type: "error" });
            };
            fileReader.readAsText(blob); // 或者读取response.data
          } else {
            if ("msSaveOrOpenBlob" in navigator) {
              // 兼容ie
              window.navigator.msSaveOrOpenBlob(blob, blob + "");
            } else {
              const link = document.createElement("a");
              link.style.display = "none";
              link.href = URL.createObjectURL(blob);
              link.setAttribute("download", blob);
              document.body.appendChild(link);
              link.click();
              document.body.removeChild(link);
            }
          }
        });
      } else {
        this.$message.warning("没有个性签名，请先上传");
      }
    },
    // 预览
    async pieView({ userId }) {
      this.imageUrl = '';
      tzService.stampDownload(userId).then((blob) => {
        this.imageUrl = URL.createObjectURL(blob);
      });
    }
  }
};
</script>

<style lang="scss">
.el-popover.deptNamePopperStyle {
  background: linear-gradient(304.17deg, rgba(244, 250, 255, 0.6) -6.04%, rgba(247, 249, 255, 0.6) 85.2%);
  box-shadow: 0px 4px 7px rgba(224, 224, 224, 0.48);
  backdrop-filter: blur(5px);
  border-radius: 6px;
}
</style>
<style lang="scss" scoped>
$main_color: #2bc9ac;
.person_table {
  height: 100%;
  .name-wrapper {
    .deptName {
      background: rgba(47, 141, 251, 0.05);
      border: 1px solid var(--theme-color);
      border-radius: 2px;
      color: var(--theme-color);
      padding: 0 10px;
      margin-right: 5px;
      display: inline-block;
      margin-bottom: 2px;
      position: relative;
      &.isMain {
        color: $main_color;
        &::before {
          position: absolute;
          display: block;
          content: "主";
          left: 0;
          top: 0;
          color: #fff;
          font-size: 10px;
          text-align: left;
          text-indent: 2px;
          height: 20px;
          width: 20px;
          line-height: 10px;
          clip-path: path("M0,0L16,0L0,16Z");
          background-color: $main_color;
        }
      }
    }
  }
}
.popover-wrapper {
  .icon {
    width: 10px;
    height: 10px;
    border-radius: 50%;
    background: #165dff;
    display: inline-block;
    margin-right: 10px;
  }
  .deptName {
    width: 218px;
    min-height: 32px;
    color: #4e5969;
    padding: 0px 6px;
    margin-bottom: 6px;
    background: rgba(255, 255, 255, 0.9);
    box-shadow: 6px 0px 20px rgba(34, 87, 188, 0.1);
    border-radius: 4px;
    display: flex;
    align-items: center;
    &.isMain .icon {
      background-color: $main_color;
    }
  }
  .fullDeptName {
    width: 192px;
  }
}
::v-deep .cell{
  font-size: 14px !important;
  span{
    font-size: 14px !important;
  }
}
.table-cell-edit-block{
  font-size: 14px !important;
}
</style>
